import { Directive, inject, input, InputSignal } from '@angular/core';

import { PhOverlayCloseResult, PhOverlayRef } from '@ph-core/services/overlay';

@Directive({
  selector: '[ph-overlay-close]',
  host: {
    '(click)': 'close()',
  }
})
export class PhOverlayCloseDirective {
  value: InputSignal<PhOverlayCloseResult> = input.required({ alias: 'ph-overlay-close' });

  private ref = inject<PhOverlayRef<unknown>>(PhOverlayRef);

  close(): void {
    this.ref.close(this.value());
  }
}
